<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/voorraad">Voorraad</a>
				</li>
				<li>
					<span>{{ bundle.name }}</span>
				</li>
			</ul>
		</div>

		<c-splitbutton class="margin-b-24" :buttons="buttons" v-if="buttons.length"></c-splitbutton>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Bundel</span>
			</div>
			<div class="columns small-12 medium-8">
				{{bundle.name}}
			</div>
		</div>

		<c-checkbox
			:options="bundle.client?.products"
			v-model="productSelection"
		/>
	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CBreadcrumbs from '@components/Breadcrumbs';
import CSplitbutton from '@components/Splitbutton';

export default {
	mixins: [ View, Form ],
	components: { CTable, CBreadcrumbs, CSplitbutton },

	data() {
		return {
			bundle: {},
			productSelection: [],
		}
	},
	methods: {
		removeFromBundle() {
			this.$xhr.put('/api/bundles/' + this.$route.params.id, {products: this.productSelection}).then(result => {
				this.$store.dispatch('toast/success', {title: 'Bundelproducten', text: 'De bundelinhoud is gewijzigd'});
			}).catch(error => {
				this.$store.dispatch('toast/alert', {title: 'Bundelproducten', text: 'Er is helaas iets fout gegaan bij het wijzigen van de bundelinhoud'});
			});
		}
	},
	beforeUnmount(){
		this.$store.dispatch("listener/off", {
			event: 'remove-from-bundle',
			listener: this.removeFromBundle
		});
	},
	created(){
		this.$store.dispatch("listener/on", {
			event: 'remove-from-bundle',
			listener: this.removeFromBundle
		});
	},
	computed: {
		buttons() {
			return [
			]
		}
	},
	mounted() {
		this.$xhr.get('/api/bundles/' + this.$route.params.id).then(result => result.result.data ?? result.result).then(data => {
			this.bundle = data;
			this.productSelection = this.bundle.products.map(({id}) => id)
		})
	}
}
</script>
